import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { jwtDecode, JwtPayload } from "jwt-decode";
import { LoginLayoutService } from '../../layouts/login-layout/login-layout.service';
import { CommonService } from '../../shared/common.service';
import { StorageService, StorageKey } from '../../shared/storage.service';
import { ActivatedRoute, Router } from '@angular/router';
import { UserLayoutService } from '../../layouts/user-layout/user-layout.service';
import { FooterService } from '../../components/footer/footer.service';
import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
const countryData = require('../country-code.json');
declare const $: any;
@Component({
  selector: 'app-profile',
  templateUrl: './family-members.component.html',
  styleUrls: ['./family-members.component.css']
})
export class FamilyMembersComponent implements OnInit {

  Editdetails: FormGroup;
  submitted = false;
  familyMember: any[] = [];
  errorMessage: string = '';
  userId: string = '';
  memberId: string = '';
  id: string;
  countries: any[] = [];
  countryData = countryData;
  noBookingData = false;

  selectedMember: any = {
    name: '',
    gender: '',
    age: '',
    email: '',
    password: '',
    countryCode: '',
    mobilenumber: ''
  };

  constructor(private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient,
    public commonService: CommonService,
    public userLayoutService: UserLayoutService,
    public storageService: StorageService,
    private footerService: FooterService
  ) { }

  ngOnInit(): void {
    this.footerService.hideFooter();
    this.userId = localStorage.getItem("_id");
    if(!this.userId) {
      this.router.navigate(['']);
    }
    this.fetchFamilyMember();
    this.route.queryParams.subscribe(params => {
      this.id = params['id'];
      if (this.id) {
        this.editMember(this.id);
      }
    });
    this.fetchCountries()
  }

  // Method to fetch user profile using token
  fetchFamilyMember(): void {
    //const token = this.storageService.getValue(StorageKey.myToken); 
    this.userLayoutService.FamilyMember(this.userId).subscribe((response: any) => {
      if (response.code === 1) {
        this.familyMember = response.data;
        // console.log("FamilyMemberData", this.familyMember);
        this.noBookingData = false;
      } else {
        this.errorMessage = response.message;
        this.noBookingData = true;

        // this.commonService.notifier.notify('error', response.message);
      }
    },
      (error) => {
        this.noBookingData = true;
        this.errorMessage = 'Failed to fetch profile data';
        // console.log('Family Member API Error:', error);
        // this.commonService.notifier.notify('error', this.errorMessage);
      });
  }

  validateEmail(): string | null {
    if (this.selectedMember.email && this.selectedMember.email.trim() !== '') {
      const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!emailPattern.test(this.selectedMember.email)) {
        return 'Invalid email format';
      }
    }
    return null; // No validation error
  }

  // validateMobileNumber(): string | null {
  //   if (
  //     this.selectedMember.mobileNumber &&
  //     this.selectedMember.mobileNumber.trim() !== ''
  //   ) {
  //     if (!/^\d{10}$/.test(this.selectedMember.mobileNumber)) {
  //       return 'Invalid mobile number. It must be 10 digits.';
  //     }
  //   }
  //   return null; // No validation error
  // }


  // Navigate to edit page
  navigateToEditPage(memberId: string): void {
    this.router.navigate([`/edit-family-member/${memberId}`]);
  }

  searchByName(term: string, item: any): boolean {
    term = term.toLowerCase();
    return item.name.toLowerCase().includes(term) || item.dial_code.toLowerCase().includes(term) || item.code.toLowerCase().includes(term);
  }

  customEmailValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      const isValidEmail = emailPattern.test(control.value);
      return isValidEmail ? null : { 'invalidEmail': true };
    };
  }

  validateCountryCode(): string | null {
    if (this.selectedMember.mobileNumber && !this.selectedMember.countryCode) {
      return 'Country code is required ';
    }
    return null;
  }

  validateMobileNumber(): string | null {
    if (this.selectedMember.countryCode && !this.selectedMember.mobileNumber) {
      return 'Mobile number is required';
    }

    if (
      this.selectedMember.mobileNumber &&
      !/^\d{8,12}$/.test(this.selectedMember.mobileNumber)
    ) {
      return 'Invalid mobile number.';
    }

    return null;
  }

  fetchCountries() {
    this.http.get<any[]>('https://restcountries.com/v3.1/all').subscribe(
      (data) => {
        this.countries = data.map((country) => {
          return {
            name: country.name.common,
            dialCode: `${country.idd?.root}${country.idd?.suffixes ? country.idd.suffixes[0] : ''}`,
            flag: country.flags.png,
          };
        });
      },
      (error) => {
        console.error('Error fetching country data', error);
        this.errorMessage = "Unable to fetch country codes. Please try again later.";
      }
    );
  }

  goBack(): void {
    this.router.navigate(['profile']);
  }

  mobilenumberInput(event: any): void {
    const input = event.target;
    input.value = input.value.replace(/[^0-9]/g, '');
  }

  editMember(id: string): void {
    this.userLayoutService.GetFamilyMemberById({ id }).subscribe(
      (response: any) => {
        if (response.code === 1) {
          this.selectedMember = response.data;
          if(!this.selectedMember.countryCode) {
            this.selectedMember.countryCode = '+1'
          }
        } else {
          this.errorMessage = response.message;
          this.commonService.notifier.notify('error', response.message);
        }
      },
      (error) => {
        this.errorMessage = 'Failed to fetch family member data';
        this.commonService.notifier.notify('error', this.errorMessage);
      }
    );
  }

  // Update the family member details
  onUpdateMember(): void {
    const emailError = this.validateEmail();
    const mobileError = this.validateMobileNumber();
      const countryCodeError = this.validateCountryCode();
      this.closeUpperModel(null, 'editinformationSidebar');
    if (emailError) {
      this.commonService.notifier.notify('error', emailError);
      return;
    }
    if (mobileError) {
      this.commonService.notifier.notify('error', mobileError);
      return;
    }
    if (countryCodeError) {
      this.commonService.notifier.notify('error', countryCodeError);
      return;
    }

    this.userLayoutService.UpdateFamilyMember(this.selectedMember).subscribe(
      (response: any) => {
        if (response.code === 1) {
          this.commonService.notifier.notify('success', 'Family member updated successfully');
          this.fetchFamilyMember();
        } else {
          this.commonService.notifier.notify('error', response.message);
        }
      },
      (error) => {
        // console.log('Update Family Member API Error:', error);
        this.commonService.notifier.notify('error', 'Failed to update family member');
      }
    );
    }

    closeUpperModel(modal: string | null, offcanvas: string | null): void {
        if (modal) {
            $(`#${modal}`).modal('hide');
        }
        if (offcanvas) {
            ($(`#${offcanvas}`) as any).offcanvas('hide');
        }
    }

}
